import {
  SPELL_CHECK_REQUESTED,
  SPELL_CHECK_SUCCEED,
  SPELL_CHECK_FAILED,
  SPELL_CHECK_REPLACE,
  SPELL_CHECK_REMOVE_SPELLING,
} from './constants';

export function spellCheck() {
  return {
    type: SPELL_CHECK_REQUESTED,
  };
}

export function spellCheckBlock(key) {
  return {
    type: SPELL_CHECK_REQUESTED,
    payload: { key },
  };
}

export function spellCheckSucceed(data, key) {
  return {
    type: SPELL_CHECK_SUCCEED,
    payload: { data, key },
  };
}

export function spellCheckFailed(errors, key) {
  return {
    type: SPELL_CHECK_FAILED,
    payload: { errors, key },
  };
}

export function spellCheckReplace(word, suggestion, key) {
  return {
    type: SPELL_CHECK_REPLACE,
    payload: { word, suggestion, key },
  };
}

export function spellCheckRemoveSpelling(word, key) {
  return {
    type: SPELL_CHECK_REMOVE_SPELLING,
    payload: { word, key },
  };
}
